import React from 'react';
import { Property } from '../../../types';
import { isHabiProperty } from '../../../utils/ownerNormalization';
import { InformationCircleIcon } from '../../Icons';

interface HabiPurchaseRightBadgeProps {
  property: Property;
  className?: string;
}

export const HabiPurchaseRightBadge: React.FC<HabiPurchaseRightBadgeProps> = ({ property, className = '' }) => {
  if (!isHabiProperty(property)) {
    return null;
  }

  return (
    <div
      id="habi-purchase-right-badge"
      className={`bg-purple-50/90 border border-purple-200/80 rounded-2xl p-4 sm:p-5 shadow-sm text-purple-950 transition-all ${className}`}
    >
      <div className="flex items-start gap-3">
        <div className="p-2 bg-purple-100/80 text-purple-700 rounded-xl shrink-0 mt-0.5">
          <InformationCircleIcon className="w-5 h-5" />
        </div>
        <div className="space-y-1">
          <div className="flex flex-wrap items-center gap-2">
            <span className="bg-purple-700 text-white text-[10px] font-black uppercase tracking-wider px-2.5 py-0.5 rounded-md">
              Derecho de compra
            </span>
            <span className="text-[11px] font-bold text-purple-700 font-mono">
              1.5% – 3%
            </span>
          </div>
          <p className="text-xs sm:text-sm text-purple-900/90 leading-relaxed font-medium">
            Este inmueble cuenta con un derecho de compra adicional estimado entre el{' '}
            <strong className="font-bold text-purple-950">1.5% y el 3%</strong> sobre el valor de la propiedad, no
            incluido en el precio publicado.
          </p>
        </div>
      </div>
    </div>
  );
};
